import React, { useEffect, useState , useMemo } from 'react'
import URL from '../constants/ServerUrl'
import axios from 'axios'
import { useSearchParams  } from 'react-router-dom'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'
import { formatDateInBS } from '../utils/formatDate'
import SkeletonLoader from './Skeletos'



const MilkReport = ({route}) => {
  // FOR DATE PICKER
  const savedDate = convertDateToBS(new Date())
  const [startDate, setStartDate] = useState(convertDateToBS(Date.now() - 30 * 24 * 60 * 60 * 1000))
  const [endDate, setEndDate] = useState(convertDateToBS(Date.now()))
  const [isPickerShow1, setIsPickerShow1] = useState(false)
  const [isPickerShow2, setIsPickerShow2] = useState(false)
  const [startDateString, setStartDateString] = useState("");
  const [endDateString, setEndDateString] = useState("");
  const [tableData, setTableData] = useState([])
  const [farmerData, setFarmerData] = useState([])
  const [farmerName, setFarmerName] = useState('No Farmer')
  const [farmerId, setFarmerId] = useState(null)
  const [shift, setShift] = useState("Both")
  const [loading, setLoading] = useState(false)
  const [focus, setFocus] = useState(false)
  const [totalMilk, setTotalMilk] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const token = localStorage.getItem("dairy-token")
  
  // FOR SEARCH BOX
  const [search, setSearch] = useState('')

  const [filteredTableData, setFilteredTableData] = useState([])

  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [prevStartDate, setPrevStartDate] = useState(startDate);
  const [prevEndDate, setPrevEndDate] = useState(endDate);
  const [prevShift, setPrevShift] = useState(shift);

  // Create a debounce function
  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, delay);
    };
  };

  // Function to handle search changes after debouncing
  const handleSearchDebounced = React.useCallback(
    debounce((searchValue) => {
      setDebouncedSearch(searchValue);
      if (searchValue === '') {
        setFarmerName("No Farmer");
      }
    }, 300), // Adjust the debounce delay as needed
    []
  );

  // Trigger API requests when debouncedSearch changes
  useEffect(() => {
    handleSearchDebounced(search); // Update the debounced value
  }, [search, handleSearchDebounced]);

  // FOR TABLE
  const tableHead = React.useMemo(() => [
    { label: 'Shift', flex: 0.10 },
    { label: 'Date', flex: 0.25 },
    { label: 'Qty', flex: 0.15 },
    { label: 'Fat', flex: 0.15 },
    { label: 'Snf', flex: 0.15 },
    { label: 'Amount', flex: 0.2 },
  ])

  const fetchAllFarmers = async () => {
    try {
      const res = await axios.get(`${URL}user/${username}/farmer`)
      setFarmerData(res.data)
      console.log(res.data);
    }
    catch(err)
    {
      console.log(err)
    }
  }

  const fetchFarmerCollections = async () => {

    try {
      setLoading(true)
      let startAD=convertDateToAD(startDate);
      let endAD=convertDateToAD(endDate)
      const  res = await axios.get(`${URL}user/${username}/collection/report?startDate=${startAD}&endDate=${endAD}&shift=${shift}`)

      console.log(res.data);

      const collectionArray = res.data.map((collection) => {
        return [
          collection.farmerId,
          collection.shift === "Morning" ? "M" : "E",
          formatDateInBS(collection.collectionDate),
          collection.qty,
          collection.fat,
          collection.snf,
          collection.amount,
        ]
      })
      
      setTableData(collectionArray)
      setLoading(false)
    }
    catch(err)
    {
      setLoading(false)
      console.log(err)
    }
  }
  useEffect(() => {
    // fetchFarmerCollections()
    fetchAllFarmers()
  }, [])

  useEffect(() => {
    // Define a flag to check if any of the relevant state values have changed
    const shouldFetchData =
      debouncedSearch !== search ||
      startDate !== prevStartDate ||
      endDate !== prevEndDate ||
      shift !== prevShift;
  
    if (shouldFetchData) {
      // Update the previous state values
      setPrevStartDate(startDate);
      setPrevEndDate(endDate);
      setPrevShift(shift);
  
      // Make the API request only if necessary
      fetchFarmerCollections();
    }
  }, [debouncedSearch, startDate, endDate, shift, search, prevStartDate, prevEndDate, prevShift])

  useEffect(() => {
    if (farmerId != null) {
      setFilteredTableData(tableData.filter((row) => row[0] == farmerId))
    }
  }, [farmerId, tableData])

  useEffect(() => {
    if (filteredTableData.length > 0) {
      let totalMilk = 0
      let totalAmount = 0
      filteredTableData.forEach((row) => {
        totalMilk += row[3]
        totalAmount += row[6]
      })
      setTotalMilk(totalMilk.toFixed(2))
      setTotalAmount(totalAmount.toFixed(2))
    }
  }, [filteredTableData])

  useEffect(() => {
    const nepalDate = String(startDate)
    setStartDateString(nepalDate)
  }, [startDate]);

  useEffect(() => {
    const nepalDate = String(endDate)
    setEndDateString(nepalDate)
  }, [endDate]);

  const showPicker1 = () => {
    setIsPickerShow1(true)
  }
  const showPicker2 = () => {
    setIsPickerShow2(true)
  }

  const onChangeStart = ( value) => {
   
    setStartDate(value)
  }

  const onChangeEnd = ( value) => {

    setEndDate(value)
  }
  

  return (
    <div className="container mx-auto p-4">
    <input
      className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
      placeholder='Search by name'
      onChange={(e) => {
        setSearch(e.target.value);
        handleSearchDebounced(e);
        if (e === '') {
          setFarmerId(null);
          setFarmerName('No Farmer');
          setTotalAmount(0);
          setTotalMilk(0);
          setFocus(false);
        } else {
          setFocus(true);
        }
      }}
      value={search}
    />
  
    {focus && (
      <div className="mt-4 bg-white shadow rounded-md">
        {search !== '' && farmerData.filter(({ farmerName, farmerId }) => {
          if (!isNaN(parseFloat(search))) return search == farmerId;
          return farmerName.toLowerCase().startsWith(search.toLowerCase());
        }).map((item) => (
          <div 
            className="p-2 border-b border-gray-200 cursor-pointer hover:bg-gray-100"
            key={item._id} 
            onClick={() => {
              setFarmerId(item.farmerId);
              setFarmerName(item.farmerName);
              setSearch(item.farmerName);
              setFocus(false);
              document.activeElement.blur();
            }}
          >
            <div className="font-semibold">{item.farmerId}</div>
            <div className="font-italic">{item.farmerName}</div>
          </div>
        ))}
      </div>
    )}
  
    {!focus && (
      <>
        <div className="mt-4">
          <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
            <div className="text-sm font-semibold">From</div>
            <div className={isPickerShow1 ? "border-blue-500" : ""}>
              {isPickerShow1 ? (
                <NepaliDatePicker
                  inputClassName="form-control"
                  className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
                  value={startDate}
                  onChange={onChangeStart}
                  options={{ calenderLocale: 'en', valueLocale: 'en' }}
                />
              ) : (
                <button mode='text' icon='calendar-today' className="flex space-x-2 mt-2" onClick={showPicker1}>
                  <div>{startDateString}</div>
                </button>
              )}
            </div>
  
            <div className="text-sm font-semibold">To</div>
            <div className={isPickerShow2 ? "border-blue-500" : ""}>
              {isPickerShow2 ? (
                <NepaliDatePicker
                  inputClassName="form-control"
                  className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
                  value={endDate}
                  onChange={onChangeEnd}
                  options={{ calenderLocale: 'en', valueLocale: 'en' }}
                />
              ) : (
                <button mode='text' icon='calendar-today' className="flex space-x-2 mt-2" onClick={showPicker2}>
                  <div>{endDateString}</div>
                </button>
              )}
            </div>
          </div>
        </div>
  
        <div className="mt-4 bg-white shadow rounded-lg p-4">
          <div className="flex justify-between items-center">
            <div className="font-semibold text-lg">
              Id: {farmerId}
            </div>
            <div className="font-semibold text-lg">
              {farmerName}
            </div>
          </div>
  
          <div className="flex space-x-4 mt-4 justify-center">
            {['Morning', 'Evening', 'Both'].map((shiftType) => (
              <button
                className={`font-bold py-2 px-4 rounded mr-4 ${shift === shiftType ? "bg-blue-200" : ""}`}
                key={shiftType}
                onClick={() => setShift(shiftType)}
              >
                Set {shiftType}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-4">
    <table className="min-w-full">
        <thead>
            <tr className="border-b border-gray-200">
                {tableHead.map((header, index) => (
                    <th key={index} className="font-semibold text-gray-700 px-6 py-3 text-left">
                        {header.label}
                    </th>
                ))}
            </tr>
        </thead>
        
    </table>
</div>

  
        {loading && (
          <div className="mt-4">
            <SkeletonLoader />
          </div>
        )}
  
        {!loading && search === '' && (
          <div className="mt-4 text-gray-600">
            <div>Please Search Milkreport</div>
          </div>
        )}
  
        {!loading && search !== '' && filteredTableData.length === 0 && (
          <div className="mt-4 text-red-500">
            <div>No Collection Found</div>
          </div>
        )}
  
        {!loading && search !== '' && filteredTableData.length > 0 && (
         <div className="mt-4">
         <div className="table w-full text-sm text-left text-gray-500">
           {filteredTableData.map((rowData, index) => (
             <div key={index} className={`flex border-b border-gray-200 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
               {rowData.slice(1).map((cellData, cellIndex) => (
                 <div key={cellIndex} className="px-6 py-4 flex-grow">
                   {cellData}
                 </div>
               ))}
             </div>
           ))}
         </div>
       </div>
       
        )}
  
        <div className="mt-4 bg-white shadow rounded-lg p-4">
          <div className="flex justify-between text-lg font-semibold">
            <div>Total Milk:</div>
            <div>{totalMilk} ltr</div>
          </div>
          <div className="flex justify-between text-lg font-semibold mt-2">
            <div>Total Amount:</div>
            <div>Rs {totalAmount}</div>
          </div>
        </div>
      </>
    )}
  </div>
  
  )
}



export default MilkReport